<div class="sidenav">
  @if (showDocumentMenu) {
    <div class="main-items">
      <div class="item">
        <a
          routerLink="/work-order/{{ workOrderId }}/documents"
          class="menu-item"
          title="Back to documents"
          data-ai-id="wo-nav-back-to-documents"
        >
          <em class="material-icons menu-item-icon icon">keyboard_arrow_left</em>
        </a>
      </div>
    </div>
  } @else {
    <div class="main-items">
      <div class="item">
        <a
          routerLink="/work-order/{{ workOrderId }}"
          routerLinkActive="item-active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="menu-item"
          (click)="clearMarkupDocument()"
          data-ai-id="wo-nav-overview"
        >
          <em class="material-icons menu-item-icon icon">dashboard</em>
        </a>
      </div>
      <div class="item">
        <a
          routerLink="/work-order/{{ workOrderId }}/materials"
          routerLinkActive="item-active"
          class="menu-item"
          (click)="clearMarkupDocument()"
          data-ai-id="wo-nav-materials"
        >
          <em class="material-icons menu-item-icon icon">line_style</em>
          @if (materialCommentCount != 0) {
            <em class="comments-count-icon">{{ materialCommentCount }}</em>
          }
        </a>
      </div>
      <div class="item">
        <a
          routerLink="/work-order/{{ workOrderId }}/objects"
          routerLinkActive="item-active"
          class="menu-item"
          (click)="clearMarkupDocument()"
          data-ai-id="wo-nav-objects"
        >
          <em class="material-icons menu-item-icon icon">list</em>
          @if (workLineCommentCount != 0) {
            <em class="comments-count-icon">{{ workLineCommentCount }}</em>
          }
        </a>
      </div>
      <div class="item">
        <a
          [routerLink]="showSplitView ? [] : ['/work-order', workOrderId, 'documents']"
          routerLinkActive="item-active"
          class="menu-item"
          [class.menu-item-disabled]="showSplitView"
          [attr.aria-disabled]="showSplitView"
          [attr.tabindex]="showSplitView ? -1 : 0"
          (click)="onDocumentsClick($event); clearMarkupDocument()"
          data-ai-id="wo-nav-documents"
        >
          <em class="material-icons menu-item-icon icon">description</em>
        </a>
      </div>
      @if (activeMarkupDocumentId) {
        <div class="item">
          <a
            routerLink="/work-order/{{ workOrderId }}/pdf-markup/{{ activeMarkupDocumentId }}"
            routerLinkActive="item-active"
            class="menu-item"
            title="Edit document"
            data-ai-id="wo-nav-markup"
          >
            <em class="material-icons menu-item-icon icon">edit_document</em>
          </a>
        </div>
      }
      <div class="item">
        @if (canUseSplitView) {
          <button
            class="menu-item split-view-btn"
            [class.item-active]="showSplitView"
            (click)="toggleSplitView(); clearMarkupDocument()"
            title="Toggle document split view"
            data-ai-id="wo-nav-split-view"
          >
            <em class="material-icons menu-item-icon icon">vertical_split</em>
          </button>
        }
      </div>
      @if (showWeightHandling) {
        <div class="item">
          <a
            routerLink="/work-order/{{ workOrderId }}/weight-report"
            routerLinkActive="item-active"
            class="menu-item"
            title="{{ 'weightReport.title' | translate }}"
            (click)="clearMarkupDocument()"
            data-ai-id="wo-nav-weight-report"
          >
            <em class="material-icons menu-item-icon icon">scale</em>
            @if (weightLineCounts.total > 0) {
              <em class="comments-count-icon weight-count-icon" [class.count-alert]="weightBadgeAlert">
                {{ weightLineCounts.sent }}/{{ weightLineCounts.total }}
              </em>
            }
          </a>
        </div>
      }
      @if (showWorkOrderFeedback) {
        <div class="item">
          <a
            routerLink="/work-order/{{ workOrderId }}/feedback"
            routerLinkActive="item-active"
            class="menu-item"
            title="{{ 'workOrderFeedback.title' | translate }}"
            (click)="clearMarkupDocument()"
            data-ai-id="wo-nav-feedback"
          >
            <em class="material-icons menu-item-icon icon">sentiment_satisfied</em>
          </a>
        </div>
      }
      @if (showSiteQueries) {
        <div class="item">
          <a
            routerLink="/work-order/{{ workOrderId }}/site-queries"
            routerLinkActive="item-active"
            class="menu-item"
            title="{{ 'siteQuery.title' | translate }}"
            [attr.aria-label]="('siteQuery.title' | translate) + ': ' + siteQueryCount"
            (click)="clearMarkupDocument()"
            data-ai-id="wo-nav-site-queries"
          >
            <mat-icon svgIcon="site-query" class="menu-item-icon icon site-query-icon" aria-hidden="true"></mat-icon>
            @if (siteQueryCount > 0) {
              <em class="comments-count-icon site-query-count-icon" aria-hidden="true">{{ siteQueryCount }}</em>
            }
          </a>
        </div>
      }
    </div>
    <div class="additional-items">
      <div class="item">
        <a
          routerLink="/work-order/{{ workOrderId }}/comments"
          routerLinkActive="item-active"
          class="menu-item"
          (click)="clearMarkupDocument()"
          data-ai-id="wo-nav-comments"
        >
          <em class="material-icons menu-item-icon icon">comment</em>
          @if (commentCount != 0) {
            <em class="comments-count-icon">{{ commentCount }}</em>
          }
        </a>
      </div>
    </div>
  }
</div>
